import { render } from "./ChronicleCreateEditView.vue?vue&type=template&id=04f2228e&scoped=true"
import script from "./ChronicleCreateEditView.vue?vue&type=script&lang=js"
export * from "./ChronicleCreateEditView.vue?vue&type=script&lang=js"

import "./ChronicleCreateEditView.vue?vue&type=style&index=0&id=04f2228e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f2228e"]])

export default __exports__